module.exports = __webpack_public_path__ + "static/media/ACT 1963 JNKVV_compressed.3e7fd96d.pdf";